import React from 'react';
import styled from 'styled-components';

const StyledLink = styled.a`
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: ${({ theme }) => theme.fontSize.base};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  
  color: ${({ theme, $variant }) => {
    if ($variant === 'primary') return theme.colors.primary.main;
    if ($variant === 'secondary') return theme.colors.secondary.main;
    if ($variant === 'thermal') return theme.colors.thermal.warm;
    return theme.colors.primary.main;
  }};
  
  text-decoration: none;
  cursor: pointer;
  
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  
  padding: ${({ $padding }) => $padding || '0'};
  
  border-radius: 4px;
  
  transition: all ${({ theme }) => theme.duration.fast}ms ${({ theme }) => theme.easing.easeOut};
  
  &:hover {
    color: ${({ theme, $variant }) => {
      if ($variant === 'primary') return theme.colors.primary.light;
      if ($variant === 'secondary') return theme.colors.secondary.light;
      if ($variant === 'thermal') return theme.colors.thermal.hot;
      return theme.colors.primary.light;
    }};
    
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 2px;
  }
  
  &:active {
    transform: translateY(1px);
  }
  
  ${({ $underline }) => $underline && `
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 2px;
  `}
  
  ${({ $noHover }) => $noHover && `
    &:hover {
      text-decoration: none;
      transform: none;
    }
  `}
  
  ${({ $external }) => $external && `
    &::after {
      content: '↗';
      font-size: 0.8em;
      opacity: 0.7;
    }
  `}
  
  ${({ $disabled, theme }) => $disabled && `
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  `}
`;

const Link = React.forwardRef(
  ({ children, variant = 'primary', underline = false, noHover = false, external = false, disabled = false, href, onClick, ...props }, ref) => {
    return (
      <StyledLink
        ref={ref}
        href={href}
        onClick={onClick}
        $variant={variant}
        $underline={underline}
        $noHover={noHover}
        $external={external}
        $disabled={disabled}
        {...props}
      >
        {children}
      </StyledLink>
    );
  }
);

Link.displayName = 'Link';

export default Link;